// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1uLf5","inputWrap":"Table_inputWrap__3qYWq","col":"Table_col__1B9kQ","bmiTooltip":"Table_bmiTooltip__1tBpV"};